module.exports = __webpack_public_path__ + "static/img/widget-modal.36f3b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/widget-modal.png
// module id = 98tf
// module chunks = 1